import {
  IGetPromosParams,
  IPromoPaginatedResponse,
  IPromotionRepository,
} from "@/core/repositories/promotion";

export class GetPromotionsUseCase {
  constructor(private readonly repo: IPromotionRepository) {}

  async execute(params: IGetPromosParams, refetch = false): Promise<IPromoPaginatedResponse> {
    return this.repo.getPromotions(params, refetch);
  }
}
